import { Form, Input, InputNumber, Switch, Row, Col, Button, Tabs } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

import {
   Site
} from "../../model/model";

import { onFinishFailed } from "../helpers";

interface IProps {
  initialValues: Site;
  onFinish: (obj: Site) => void;
  update?: boolean;
}

function SiteForm(props: IProps) {
  const onFinish = (values: Site) => {
    const v = Object.assign(props.initialValues, values);

    const site :Site = {
      id: v.id,
      name: v.name,
      topic: v.topic,
      subId: v.subId,
      orgId: v.orgId,
    }
    props.onFinish(site);
  };

  return (
    <Form
      layout="vertical"
      initialValues={props.initialValues}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Tabs>
        <Tabs.TabPane tab="General" key="1">
          <Form.Item label="Id" name="id" rules={[{ required: true, message: "Please enter a ID!" }]}>
            <Input disabled={props.update} />
          </Form.Item>
          <Form.Item label="Name" name="name" rules={[{ required: true, message: "Please enter a name!" }]}>
            <Input  />
          </Form.Item>
          <Form.Item label="Description" name="description">
            <Input.TextArea  />
          </Form.Item>
        </Tabs.TabPane>
      </Tabs>
      <Form.Item>
        <Button type="primary" htmlType="submit" >
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
}

export default SiteForm;
